import { getDelayAction } from 'automaton/actions/DelayAction'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { timings } from 'settings/custom/freespins'

export function getFreespinEndDelayState() {
  const name = 'FS-END-DELAY'
  const actions = [getDelayAction(timings.after)]
  const transition = getFreespinEndState

  return {
    name,
    actions,
    transition,
  }
}
